import { 
    AllInclusive, 
    Checkroom, 
    Flare, 
    Movie, 
    Spa, 
    Sports, 
    SportsBar, 
    TravelExplore,
    Restaurant,
    Palette,
    Computer,
    Business,
    School,
    MusicNote,
    Nature,
    SportsEsports,
    CameraAlt,
    VolunteerActivism,
    FitnessCenter,
    MenuBook,
    Favorite,
    DateRange,
    Work,
    BuildCircle
} from "@mui/icons-material"

export const CategoryDisplay = ({label, hideLabel}) => {

    const CatView = {alignContent:'center', display:'flex'}

    const displayLocally = (Icon, label) => {
        return (
            <div style={CatView}>
                {Icon}
                {!hideLabel && <span style={{fontWeight:"bold"}}>{label}</span>}
            </div>

        )
    }
    
    return (
        <div style={{paddingBottom:10, marginBottom:5}}>
            {label === "social" && displayLocally(<SportsBar />, "Social")}
            {label === "wellness" && displayLocally(<Spa />, "Wellness")}
            {label === "entertainment" && displayLocally(<Movie />, "Entertainment")}
            {label === "fashion" && displayLocally(<Checkroom />, "Fashion")}
            {label === "spirituality" && displayLocally(<Flare />, "Spirituality")}
            {label === "sport_fitness" && displayLocally(<Sports />, "Sports & Fitness")}
            {label === "travel" && displayLocally(<TravelExplore />, "Travel")}
            {label === "food_dining" && displayLocally(<Restaurant />, "Food & Dining")}
            {label === "arts_culture" && displayLocally(<Palette />, "Arts & Culture")}
            {label === "technology" && displayLocally(<Computer />, "Technology")}
            {label === "business_networking" && displayLocally(<Business />, "Business & Networking")}
            {label === "education_learning" && displayLocally(<School />, "Education & Learning")}
            {label === "music" && displayLocally(<MusicNote />, "Music")}
            {label === "outdoor_recreation" && displayLocally(<Nature />, "Outdoor & Recreation")}
            {label === "gaming" && displayLocally(<SportsEsports />, "Gaming")}
            {label === "photography" && displayLocally(<CameraAlt />, "Photography")}
            {label === "volunteer_community" && displayLocally(<VolunteerActivism />, "Volunteer & Community")}
            {label === "health_fitness" && displayLocally(<FitnessCenter />, "Health & Fitness")}
            {label === "books_literature" && displayLocally(<MenuBook />, "Books & Literature")}
            {label === "lgbtq" && displayLocally(<Favorite />, "LGBTQ+")}
            {label === "relationships_dating" && displayLocally(<DateRange />, "Relationships & Dating")}
            {label === "career_professional" && displayLocally(<Work />, "Career & Professional")}
            {label === "hobbies_crafts" && displayLocally(<BuildCircle />, "Hobbies & Crafts")}
            {label === "other" && displayLocally(<AllInclusive />, "Other")}
        </div>
    )
}